export default "__VITE_ASSET__DDLSmRIp__"